var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._b({attrs:{"previewSrcList":_vm.previewList}},'el-image',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }